import { Route, withRouter } from 'react-router-dom';

import StudyDetails from './components/Pages/StudyDetails';
import StudyIndex from './components/Pages/StudyIndex';
import StudyEdit from './components/Pages/StudyEdit';

import './Study.scoped.scss';

const Study = ({ match }) => {
  return (
    <>
      <Route exact path={`${match.path}`} component={StudyIndex} />
      <Route exact path={`${match.path}/details/:id`} component={StudyDetails} />
      <Route exact path={`${match.path}/form`} component={StudyEdit} />
    </>
  );
};

export default withRouter(Study);
